import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import OriginalsShopCard from '../../../../ShopCard/OriginalsShopCard';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

import s from './OriginalSource.scss';

export interface Props {
  block: RelatedBlock;
  deviation?: PapiDeviation;
  withHeader?: boolean;
  className?: string;
}

const OriginalSource: React.FC<Props> = ({
  block,
  deviation: parentDeviation,
  className,
  withHeader,
}) => {
  const { deviations } = block;

  const { ref, dimensions: measuredContainer } = useMeasureElementCookie(
    MeasuredCookieType.DEVIATION_SIDEBAR,
    {
      cookieDim: 'width',
    }
  );

  if (!deviations || deviations.length === 0) {
    return null;
  }
  const deviation = deviations[0];

  return (
    <SidebarBlockWrapper
      deviation={deviation}
      block={block}
      className={className}
      noHeader={!withHeader}
    >
      <BiLoggerContextProvider value={{ sectionname: block.contentType }}>
        <div ref={ref} className={s['root']}>
          <OriginalsShopCard
            key={deviation.deviationId}
            deviation={deviation}
            width={measuredContainer.width}
            withAuthorDetails
          />
        </div>
      </BiLoggerContextProvider>
    </SidebarBlockWrapper>
  );
};
OriginalSource.displayName = 'OriginalSource';

export default OriginalSource;
